module.exports = __webpack_public_path__ + "static/img/right.ad7291e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/right.png
// module id = JfLI
// module chunks = 1